import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUikitComponent } from './simple-icons-uikit.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUikitComponent ],
    exports:      [ SimpleIconsUikitComponent ],
    bootstrap:    []
})
export class SimpleIconsUikitModule {}
